import { Box } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const StyledPriceChart = styled(Box)<{
  $isDark: boolean
  $isExpanded: boolean
  $isFullWidthContainer?: boolean
}>`
  border: none;
  border-radius: 32px;
  width: 100%;
  padding-top: 16px;
  background: #1b2b45;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-top: 24px;

    border-radius: 16px;
    /* border: ${({ theme }) => `1px solid ${theme.colors.cardBorder}`}; */
    border-radius: ${({ $isExpanded }) => ($isExpanded ? '0' : '16px')};
    width: ${({ $isExpanded, $isFullWidthContainer }) => ($isFullWidthContainer || $isExpanded ? '100%' : '50%')};
    height: ${({ $isExpanded }) => ($isExpanded ? '100%' : '480px')};
  }

  .text-token {
    font-weight: 700;
    font-size: 20px;
    line-height: 140%;

    color: #ffffff;
  }

  @media only screen and (max-width: 1024px) {
    height: 100%;
  }

  @media only screen and (max-width: 600px) {
    border-radius: 0;
  }
`

StyledPriceChart.defaultProps = {
  height: '70%',
}
